import { __awaiter } from "tslib";
/**
 * Checks if user has 3rd party cookies enabled in crome. otherwise api on content app will return always 401
 * */
export function hasThirdPartyCookies() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!document.hasStorageAccess)
            return true; // old browser, assume allowed
        try {
            return yield document.hasStorageAccess();
        }
        catch (_a) {
            return false;
        }
    });
}
